<template lang="pug">
  //- アカウント追加実行画面
  #execute-add-account
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      header-for-login
      .body-width.mx-auto
        h2.text-center.pt-5.font-weight-bold.white-space パスワードを設定してください
        b-card
          .form-box.mx-auto
            //- パスワード設定フォーム
            change-password-form.my-3(:password="password", :re_password="re_password")
            b-button.float-right(v-b-modal.execute-add-modal, variant="outline-success", :disabled="isSubmitButtonDisabled") 設定する

            //- 追加実行確認ダイアログ
            b-modal#execute-add-modal(title="ご確認", ok-title="はい", cancel-title="いいえ", ok-variant="success", @ok="executeAddAccount")
              template(#modal-header-close)
                span(title="閉じる") ×
              span 入力された内容でアカウントを作成します。
                br
                | よろしいですか？
</template>

<script>
import Loading from '@/components/Loading';
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";
import ChangePasswordForm from "@/components/supportSite/ChangePasswordForm";
import Api from '@/repositories/api'

const CheckAccountRepository = Api.get('s212AccountManagement')
const CreateAccountRepository = Api.get('s212AccountManagement')

export default {
  name: 'ExecuteAddAccount',
  components: {
    Loading,
    HeaderForLogin,
    ChangePasswordForm
  },
  data() {
    return {
      // パスワード
      password: { value: "", placeholder: "6文字以上・半角英数字記号", error_msg_list: [] },

      // パスワード確認
      re_password: { value: "", placeholder: "確認のためにもう一度入力してください", error_msg_list: [] },

      // トークン情報
      add_account_token: "",

      // ローディングフラグ
      isLoading: false,

      // 「設定する」ボタン無効フラグ
      isSubmitButtonDisabled: false,
    }
  },
  // 画面表示前処理
  created() {
    // ローディング表示
    this.isLoading = true;

    // クエリパラメータからトークン取得
    this.add_account_token = this.$route.query.token;

    // リクエストパラメータ作成
    let requestParameter = {
      add_account_token: this.add_account_token
    };

    // アカウントチェック処理呼び出し
    CheckAccountRepository.check(requestParameter)
    .catch((error) => {
      // 共通のエラー処理
      this.apiError(error, "画面表示処理")

      // エラー用の画面へ遷移する
      this.$router.push({
        name: "RelatedPasswordSetting",
        params: {
          // 画面に表示するエラーメッセージ
          error_msg:error.response.data.error_list[0].error_msg
        }
      })
    })
    .finally(() => {
      // ローディング表示終了
      this.isLoading = false;
    })
  },
  methods: {
    // アカウント追加実行
    executeAddAccount() {
      // ボタンをロックする
      this.isSubmitButtonDisabled = true;

      // エラーメッセージを初期化する
      this.password.error_msg_list    = []; // パスワード
      this.re_password.error_msg_list = []; // パスワード(確認用)

      // リクエストデータ作成
      let params = {
        add_account_token: this.add_account_token, // アカウント追加トークン
        password:          this.password.value,    // パスワード
        re_password:       this.re_password.value  // パスワード(確認用)
      }

      // アカウント追加実行
      CreateAccountRepository.create(params)
      .then(() => {
        // アカウント追加完了画面へ遷移する
        this.$router.push({
          name: "DoneExecuteAddAccount"
        })
      })
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, "変更処理")

        // バリデーションエラー
        if (error.response.data && error.response.data.error_list) {
          // 全てのエラーメッセージを確認
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージの項目が指定されている場合
            if (errorData.target !== undefined && this[errorData.target] !== undefined) {
              this[errorData.target].error_msg_list.push(errorData.error_msg)
            }
            // エラーメッセージの項目がない場合
            else {
              // エラー用の画面へ遷移する
              this.$router.push({
                name: "RelatedPasswordSetting",
                params: {
                  // 画面に表示するエラーメッセージ
                  error_msg: errorData.error_msg
                }
              })
            }
          }
        }
      })
      .finally(() => {
        // ボタンのロックを解除する
        this.isSubmitButtonDisabled = false;
      })
    }
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.form-box {
  max-width: 800px;
}
</style>